import React from "react";
import VendorMrqForm from "./VendorMrqForm";

export default function VendorMrqs() {
  // const [open, setOpen] = React.useState(false);
  return (
    // <Grid container sx={{ m: 2 }}>
    //   <Grid items xs={6}>

    <VendorMrqForm />

    //   </Grid>
    //   <Grid item xs={6}>
    //     <CommentsDialog
    //       open={open}
    //       handleClose={() => {
    //         setOpen(false);
    //       }}
    //       parentId={"parentId"}
    //       parentType={"mrq"}
    //       isNotDialog={true}
    //     />
    //   </Grid>
    // </Grid>
  );
}
